import type { WorkbookSheetPreview } from './api';

export function sheetIssues(sheet: WorkbookSheetPreview, ignoredConfirmed: boolean) {
  const issues: string[] = [];
  if (!sheet.columns.includes('email')) issues.push('Email column is not mapped');
  const mapped = sheet.columns.filter(Boolean);
  const repeated = [...new Set(mapped.filter((field, i) => mapped.indexOf(field) !== i))];
  if (repeated.length) issues.push(`Repeated mapping: ${repeated.join(', ')}`);
  const width = Math.max(sheet.columns.length, ...sheet.previewRows.map(row => row.values.length));
  const ignored = Array.from({ length: width }, (_, i) => i).filter(i => !sheet.columns[i] && sheet.previewRows.some(row => row.number > sheet.headerRow && row.values[i]?.trim()));
  if (ignored.length && !ignoredConfirmed) issues.push(`Confirm ignoring populated columns: ${ignored.map(i => i + 1).join(', ')}`);
  if (!sheet.previewRows.some(row => row.number > sheet.headerRow)) issues.push('No data rows in preview after the header');
  return issues;
}
